export default {
  namespaced: true,
  state: {
    mainMenuType: 0,
    selectTowerId: +sessionStorage.getItem('Select_TowerId'),
    SelectVersionId: '',
    // 测风数据时间范围,
    dateRangeStore: [],
    selectTabId: '', //当选中测风塔管理时，为1，数据处理为2
    towerInfo: {}, //测风塔基本信息
    towerId: '', //测风塔管理选中的测风塔的id值。
    ifUpdate: '',
    modifyStatus: true, //修改测风塔信息后，状态改变，触发列表刷新。
    original: +sessionStorage.getItem('SET_ORIGINAL'),
    isOwnerFlag: +sessionStorage.getItem('SET_ISOWNERFLAG'), //是否是自己发布的版本。
    idString: '',
    towerObj: {},
    dataProcessMenu: [],
    showDownloadTable: false
  },
  getters: {},
  actions: {},
  mutations: {
    MAIN_MENU_TYPE(state, payload) {
      state.mainMenuType = payload;
    },
    SET_IFUPDATE(state, payload) {
      state.ifUpdate = payload;
    },
    SELECT_TAB(state, payload) {
      state.selectTabId = payload;
    },
    Select_TowerId(state, payload) {
      state.selectTowerId = payload;
    },
    Select_VersionId(state, payload) {
      state.SelectVersionId = payload;
    },
    SET_DATERANGE(state, payload) {
      state.dateRangeStore = payload || null;
    },
    SET_TOWERINFO(state, payload) {
      state.towerInfo = payload;
      state.towerId = payload.towerId;
    },
    SET_TOWERID(state, payload) {
      state.towerId = payload;
    },
    SET_MODIFYSTATUS(state, payload) {
      state.modifyStatus = payload;
    },
    SET_ORIGINAL(state, payload) {
      state.original = payload;
    },
    SET_ISOWNERFLAG(state, payload) {
      state.isOwnerFlag = payload;
    },
    SET_IDSTRING(state, payload) {
      state.idString = payload;
    },
    SET_TOWER_INFO(state, payload) {
      state.towerObj = payload;
    },
    SET_MENU(state, payload) {
      state.dataProcessMenu = payload;
    },
    SHOW_DOWNLOAD_TABLE(state, payload) {
      state.showDownloadTable = payload;
    }
  }
};
